import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RequestHeader = ({
  request,
  onDownload,
  onRequestRevision,
  isDownloading,
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-success bg-success/10 border-success/20';
      case 'in_progress':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'pending':
        return 'text-muted-foreground bg-muted border-border';
      case 'revision_requested':
        return 'text-accent bg-accent/10 border-accent/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'تکمیل شده';
      case 'in_progress':
        return 'در حال پردازش';
      case 'pending':
        return 'در انتظار بررسی';
      case 'revision_requested':
        return 'نیاز به بازنگری';
      default:
        return 'نامشخص';
    }
  };

  const formatPersianDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })?.format(date);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 card-shadow">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h1 className="text-2xl font-bold text-foreground">
              جزئیات درخواست #{request?.id}
            </h1>
            <div
              className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(
                request?.status
              )}`}>
              {getStatusText(request?.status)}
            </div>
          </div>
          <p className="text-muted-foreground">
            ایجاد شده در {formatPersianDate(request?.createdAt)}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          {request?.status === 'completed' && (
            <Button
              variant="default"
              iconName="Download"
              iconPosition="right"
              loading={isDownloading}
              onClick={onDownload}
              className="sm:w-auto">
              دانلود سند
            </Button>
          )}

          {(request?.status === 'completed' ||
            request?.status === 'in_progress') && (
            <Button
              variant="outline"
              iconName="MessageSquare"
              iconPosition="right"
              onClick={onRequestRevision}
              className="sm:w-auto">
              درخواست بازنگری
            </Button>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="FileText" size={18} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">
              نوع سند
            </span>
          </div>
          <p className="font-semibold text-foreground">
            {request?.documentType}
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="User" size={18} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">
              شاکی
            </span>
          </div>
          <p className="font-semibold text-foreground">
            {request?.claimantName}
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="UserX" size={18} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">
              مدعی علیه
            </span>
          </div>
          <p className="font-semibold text-foreground">
            {request?.respondentName}
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Calendar" size={18} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">
              آخرین بروزرسانی
            </span>
          </div>
          <p className="font-semibold text-foreground">
            {formatPersianDate(request?.updatedAt)}
          </p>
        </div>
      </div>
      <div className="mt-4 bg-muted/30 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="BookOpen" size={18} className="text-primary" />
          <span className="text-sm font-medium text-muted-foreground">
            موضوع درخواست
          </span>
        </div>
        <p className="text-foreground leading-relaxed">{request?.subject}</p>
      </div>
    </div>
  );
};

export default RequestHeader;
